function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCropFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 26l6.465-.06v2H4v-8.464h2V26zm21.94 1.94h-8.465v-2h6.466v-6.464h2v8.465zM12.466 6H6v6.465H4V4h8.465v2zm15.476-2v8.465h-2L26 6h-6.526V4h8.466z",
    fill: props.color
  }));
}

export default SvgIconCropFilled;